import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import api from "../../utils/api";
import "react-toastify/dist/ReactToastify.css";

const COLORS = {
  primary: "#f66061",
  primaryDark: "#d94f50",
  border: "#bbb",
};

const inputClass =
  "w-full border border-gray-300 px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-[#f66061] focus:border-transparent transition";

const labelClass = "block mb-2 text-gray-700 font-semibold";

const CreateCoupon = () => {
  const [code, setCode] = useState("");
  const [discount, setDiscount] = useState("");
  const [applicableCards, setApplicableCards] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (!code || !discount || applicableCards < 1) {
      toast.error("Please fill all fields correctly");
      return;
    }

    setIsLoading(true);
    try {
      const response = await api.post("/coupon/create", {
        code,
        discountPercentage: Number(discount),
        applicableCards: Number(applicableCards),
      });

      if (response.data.code === 200) {
        toast.success("Coupon created successfully!");
        handleReset();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to create coupon");
    } finally {
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    setCode("");
    setDiscount("");
    setApplicableCards(1);
  };

  return (
    <div className="p-4 md:p-6 max-w-4xl mx-auto bg-white rounded-lg shadow-lg">
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <h2 className="text-2xl font-bold text-gray-800 mb-6">Create Coupon</h2>

      <div className="mb-6">
        <label className={labelClass}>Coupon Code</label>
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          className={inputClass}
          placeholder="e.g. NEWYEAR2026"
        />
      </div>

      <div className="mb-6">
        <label className={labelClass}>Discount %</label>
        <input
          type="number"
          value={discount}
          onChange={(e) => setDiscount(e.target.value)}
          className={inputClass}
          max={100}
          min={1}
          placeholder="Enter discount percentage"
        />
      </div>

      <div className="mb-6">
        <label className={labelClass}>Applicable Cards</label>
        <input
          type="number"
          value={applicableCards}
          onChange={(e) => setApplicableCards(e.target.value)}
          className={inputClass}
          min={1}
          placeholder="Number of cards this coupon applies to"
        />
        <p className="text-xs text-gray-400 mt-1">
          Maximum number of cards this coupon can be applied to per use.
        </p>
      </div>

      <div className="flex space-x-4">
        <button
          onClick={handleSubmit}
          disabled={isLoading}
          style={{ backgroundColor: COLORS.primary }}
          className="text-white px-6 py-2 rounded hover:opacity-90 transition flex items-center justify-center min-w-[140px] font-medium"
        >
          {isLoading ? <ClipLoader size={20} color="#fff" /> : "Create Coupon"}
        </button>
        <button
          onClick={handleReset}
          className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-700 transition font-medium"
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default CreateCoupon;